import { useI18n } from "vue-i18n"

interface MetaProps {
    key: string;
    link?: any[],
		localeLinks?: any[],
    script?: any[],
    follow?: boolean,
		shareMeta?: any[],
    htmlAttrs?: any,
    descriptionReplace?: any
}

export const stripHtml = (html?: string):string => html?.replace(/<[^>]*>?/gm, '') ?? '';

// NOTE set i18nRef if updated localy (like inside blog)
export const buildMeta = (props: MetaProps, i18nRef?:any, i18nHeadRef?:any ) => {
   
    const i18n = i18nRef ?? useI18n()
		const route = useRoute()
		const config = useRuntimeConfig()
		const i18nHead = i18nHeadRef ?? useLocaleHead({
			addSeoAttributes: true
		}) 

		const title = i18n.t(`${props.key}.meta.title`)
		const description = props.descriptionReplace ? i18n.t(`${props.key}.meta.description`, props.descriptionReplace) : i18n.t(`${props.key}.meta.description`) 
		const links = props.localeLinks ?? i18nHead.value.link ?? []
		const canonicalUrl = links.find((link: any) => link.rel === 'canonical')?.href
			?? `${config.public.hostname}${route.path}`
		const shareMeta = props.follow && !props.shareMeta ? [
			{ name: 'twitter:title', content: title },
			{ name: 'twitter:description', content: description },
			{ property: 'og:title', content: title },
			{ property: 'og:description', content: description },
			{ property: 'og:url', content: canonicalUrl },
			{ property: 'og:type', content: 'website' },
		] : (props.shareMeta ?? [])
		const overriddenMetaKeys = new Set(
			shareMeta.map((meta: any) => meta.property ?? meta.name).filter(Boolean)
		)
		const localeMeta = (i18nHead.value.meta ?? []).filter((meta: any) =>
			!overriddenMetaKeys.has(meta.property ?? meta.name)
		)

    return {
        title,
        htmlAttrs: {
            lang: i18nHead.value.htmlAttrs!.lang,//i18n.locale,
            ...(props.htmlAttrs ?? {})
        },
        
        meta: [
            { name: "description", content: description },
            { name: "keywords", content: i18n.t(`${props.key}.meta.keywords`) },
						{ name: "robots", content: props.follow ? "index,follow" : "noindex,nofollow" },
						...shareMeta,
						...localeMeta,
        ],
        script: [
            ...(props.script ?? []),
        ],
        link: [
            ...(props.link ?? []),
						...links,
        ]
    }
}
